angular.module('app')
    .factory('SearchService', function ($http, $location, dateFilter, ATTS, ENDPOINT_SEARCH, ENDPOINT_AGGREGATE) {
      var service = {}
      service.recuperaDati = function (keywords, filtri, currentPage, itemsPerPage, sort) {
        return $http.post(ENDPOINT_SEARCH, {
          'table': ATTS.table,
          'limit': itemsPerPage,
          'skip': currentPage * itemsPerPage,
          'sort': sort || {
            'score': {
              $meta: 'textScore'
            }
          },
          'fields': {
            'id': 1,
            'preferred_label': 1,
            'representations': 1,
            'data': 1,
            'superfondo_app':1,
            'type': 1,
            'score': {
              $meta: 'textScore'
            }
          },
          'query': queryFiltri(keywords, filtri, currentPage)
        })

      }
      service.recuperaFiltri = function (keywords, filtri, currentPage) {
        if (filtri.length < 1) {
          filtri = [{}]
        }
        return $http.post(ENDPOINT_AGGREGATE, {
          'table': 'data',
          'query': [{
            '$match': queryFiltri(keywords, filtri, currentPage)
          }, {
            '$unwind': '$filtri'
          }, {
            '$group': {
              '_id': '$filtri',
              'count': {
                '$sum': 1
              }
            }
          }, {
            '$project': {
              '_id': 0,
              'count': 1,
              'data': '$_id'
            }
          }]
        })
      }

      service.getFiltriSelezionati = function () {
        var result = []
        var search = $location.search()
        if (search.types) {
          search.types = _.isArray(search.types) ? search.types : [search.types]
          _.each(search.types, function (key) {
            key.split('$-$').forEach((k) => {
              var split = _.split(k, '|')
              result.push({
                'data': {
                  'name': split[0],
                  'id': split[1],
                  'path' : split[2]
                }
              })
            })
          })
        }
        if (search.dates_from || search.dates_to) {
          var filtro = {'cronologia' : {}}
          if (search.dates_from) {
            filtro.cronologia.from = new Date(search.dates_from)
          }
          if (search.dates_to) {
            filtro.cronologia.to = new Date(search.dates_to)
          }
          result.push(filtro)
        }
        return result
      }

      service.getKeywords = function () {
        var result = []
        var search = $location.search()
        if (search.keywords) {
          search.keywords = _.isArray(search.keywords) ? search.keywords : [search.keywords]
          _.each(search.keywords, function (key) {
            result.push({
              'text': key
            })
          })
        }

        return result
      }


      service.getLastDate = function (keywords, filtri, currentPage) {
        _.remove(filtri, function (o) {
          return !!o.cronologia
        })
        let query = queryFiltri(keywords, filtri, currentPage)
        query['data_filtro.end'] = {'$exists': true}

        return $http.post(ENDPOINT_SEARCH, {
          'table': ATTS.table,
          'limit': 1,
          'skip': 0,
          'sort': {'data_filtro.start':-1},
          'fields': {
            'data_filtro': 1
          },
          'query': query
        })
      }

      service.getFirstDate = function (keywords, filtri, currentPage) {
        _.remove(filtri, function (o) {
          return Boolean(o.cronologia)
        })

        let query = queryFiltri(keywords, filtri, currentPage)
        query['data_filtro.start'] = {'$exists': true}
        return $http.post(ENDPOINT_SEARCH, {
          'table': ATTS.table,
          'limit': 1,
          'skip': 0,
          'sort': {'data_filtro.start': 1},
          'fields': {
            'data_filtro': 1
          },
          'query': query
        })
      }

      return service

      function queryFiltri (keywords, filtri, currentPage) {
        var query = {
          'table': {$in : ['ca_objects', 'ca_entities']},
          'access' : {$in : [1,2]},
          'representations' : {$exists : 1}
        }
        var search = {
          //    "currentPage" : currentPage
        }
        var types = _.filter(filtri, function (o) {
          return !!o.data
        })
           /* var keywords = _.filter(filtri, function(o) {
                return !!o.keyword;
            });*/
        var dates = _.filter(filtri, function (o) {
          return !!o.cronologia
        })
        if (!_.isEmpty(types)) {
          query['filtri.id'] = {
            '$all': _.map(types, function (item) {
              return item.data.id
            })
          }

          search.types = _.map(types, function (item) {
            return item.data.name + '|' + item.data.id + '|' + item.data.path
          }).join('$-$')

        }

        if (!_.isEmpty(keywords)) {

          var queryString = _(keywords).map(function (o) {
            return '\"' + o.text + '\"'
          }).value().join(' ')

          query.$text = {
            '$search' :queryString,
            '$language' : 'it'
          }

          search.keywords = _.map(keywords, 'text')
        }


        if (!_.isEmpty(dates)) {
          var cronologia = dates[0].cronologia
          query['data_filtro.start'] = {}
          if (cronologia.from) {
            query['data_filtro.start'].$gte = dateFilter(cronologia.from, 'yyyy-MM-dd')
            search.dates_from = query['data_filtro.start'].$gte
          }
          if (cronologia.to) {
            query['data_filtro.start'].$lt = dateFilter(cronologia.to, 'yyyy-MM-dd')
            search.dates_to = query['data_filtro.start'].$lt
          }
        }


        $location.search(search)

        return query
      }
    })



// WEBPACK FOOTER //
// ./src/js/pages/search.service.js